import { XIcon } from "@heroicons/react/outline";
import {} from "@heroicons/react/solid";
import { React, useState } from "react";

const AdminModal = ({ title, url, show, onCloseCallback }) => {
  const [tabIndex, setTabIndex] = useState(0);

  if (!show) {
    return null;
  }

  return (
    <div
      id="popup-modal"
      tabIndex="-1"
      className="fixed top-0 right-0 left-0 bottom-0 overflow-y-auto overflow-x-hidden flex justify-center items-center z-50 md:inset-0 h-modal md:h-full bg-[rgba(0,0,0,0.6)]"
    >
      <div className="relative p-4 w-full max-w-xl h-full md:h-auto">
        {/* <!-- Modal content --> */}
        <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
          {/* <!-- Modal header --> */}
          <div className="flex flex-row place-items-center justify-end">
            <h1 className="px-4 py-3 text-lg font-normal text-gray-700">
              {title}
            </h1>
            <button
              onClick={() => {
                setTabIndex(0);
                onCloseCallback();
              }}
              type="button"
              className="rounded-lg text-sm ml-auto px-4 py-3 inline-flex items-center"
              data-modal-toggle="popup-modal"
            >
              <XIcon className="w-5 h-5" />
            </button>
          </div>
          <div className="w-full h-0.5 bg-gray-200"></div>
          {/* <!-- Modal body --> */}
          <div className="h-80 drop-shadow-md">
            <ul class="flex flex-wrap border-b border-gray-200 mb-5">
              <li class="w-1/2">
                <button
                  onClick={() => setTabIndex(0)}
                  class={`w-full inline-block py-4 px-4 text-sm font-medium text-center ${
                    tabIndex === 0
                      ? "bg-gray-100 text-blue-600 active"
                      : "text-gray-500 hover:text-gray-600 hover:bg-gray-50"
                  }`}
                >
                  Delete Admins
                </button>
              </li>
              <li class="w-1/2">
                <button
                  onClick={() => setTabIndex(1)}
                  class={`w-full inline-block py-4 px-4 text-sm font-medium text-center ${
                    tabIndex === 1
                      ? "bg-gray-100 text-blue-600 active"
                      : "text-gray-500 hover:text-gray-600 hover:bg-gray-50"
                  }`}
                >
                  Add Admins
                </button>
              </li>
            </ul>
            {tabIndex === 0 ? (
              <div class="container flex justify-center mx-auto scroll-auto">
                <div class="flex flex-col">
                  <div class="w-full">
                    <div class="border-b border-gray-200 shadow">
                      <table>
                        <thead class="flex bg-gray-100 w-full">
                          <tr className="whitespace-nowrap">
                            <th class="px-6 py-4 text-sm text-gray-500">
                              <div class="text-sm w-28">ID</div>
                            </th>
                            <th class="px-6 py-4 text-sm text-gray-500">
                              <div class="text-sm w-40">Name</div>
                            </th>
                            <th class="px-6 py-4 text-sm text-gray-500">
                              <div class="text-sm w-20">Delete</div>
                            </th>
                          </tr>
                        </thead>
                        <tbody
                          class="flex flex-col overflow-y-scroll"
                          style={{ height: 22 + "vh" }}
                        >
                          <tr class="whitespace-nowrap text-center">
                            <td class="px-6 py-4">
                              <div className="text-sm text-gray-500 w-28 truncate">
                                11911404
                              </div>
                            </td>
                            <td class="px-6 py-4">
                              <div class="group text-sm text-gray-500 w-40 truncate">
                                Anubhav Pabby
                                <span class="absolute z-50 hidden px-4 py-1 -mt-12 text-center bg-gray-500 rounded tooltip-text text-gray-100 group-hover:block">
                                  Anubhav Pabby
                                </span>
                              </div>
                            </td>
                            <td class="px-6 py-4">
                              <button class="p-1 text-sm text-white bg-red-400 rounded w-20">
                                Delete
                              </button>
                            </td>
                          </tr>

                          <tr class="whitespace-nowrap text-center">
                            <td class="px-6 py-4">
                              <div className="text-sm text-gray-500 w-28 truncate">
                                11911407
                              </div>
                            </td>
                            <td class="px-6 py-4">
                              <div class="group text-sm text-gray-500 w-40 truncate">
                                Avinash Vijayvargiya
                                <span class="absolute z-50 hidden px-4 py-1 -mt-12 text-center bg-gray-500 rounded tooltip-text text-gray-100 group-hover:block">
                                  Avinash Vijayvargiya
                                </span>
                              </div>
                            </td>
                            <td class="px-6 py-4">
                              <button class="p-1 text-sm text-white bg-red-400 rounded w-20">
                                Delete
                              </button>
                            </td>
                          </tr>
                          <tr class="whitespace-nowrap text-center">
                            <td class="px-6 py-4">
                              <div className="text-sm text-gray-500 w-28 truncate">
                                11910219
                              </div>
                            </td>
                            <td class="px-6 py-4">
                              <div class="group text-sm text-gray-500 w-40 truncate">
                                Anjali Asolkar
                                <span class="absolute z-50 hidden px-4 py-1 -mt-12 text-center bg-gray-500 rounded tooltip-text text-gray-100 group-hover:block">
                                  Anjali Asolkar
                                </span>
                              </div>
                            </td>
                            <td class="px-6 py-4">
                              <button class="p-1 text-sm text-white bg-red-400 rounded w-20">
                                Delete
                              </button>
                            </td>
                          </tr>
                          <tr class="whitespace-nowrap text-center">
                            <td class="px-6 py-4">
                              <div className="text-sm text-gray-500 w-28 truncate">
                                11912357
                              </div>
                            </td>
                            <td class="px-6 py-4">
                              <div class="group text-sm text-gray-500 w-40 truncate">
                                Rutika Deshmukh
                                <span class="absolute z-50 hidden px-4 py-1 -mt-12 text-center bg-gray-500 rounded tooltip-text text-gray-100 group-hover:block">
                                  Rutika Deshmukh
                                </span>
                              </div>
                            </td>
                            <td class="px-6 py-4">
                              <button class="p-1 text-sm text-white bg-red-400 rounded w-20">
                                Delete
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div>
                <form className="flex flex-col place-items-center mb-4 w-full">
                  <div className=" flex flex-row flex-wrap justify-evenly">
                    <div className="w-5/12">
                      <label
                        className="block text-[#777777]"
                        htmlFor="Username"
                      >
                        Username
                      </label>
                      <input
                        className={`border-2 rounded-lg w-full py-1 px-4 text-gray-700 leading-none focus:bg-white border-transparent focus:border-transparent focus:ring-1 ${"bg-[#E4E6FF]"}`}
                        id="Username"
                        type="text"
                        name="Username"
                        value={null}
                        onChange={null}
                        autoComplete="off"
                        disabled={false}
                      />
                    </div>
                    <div className="w-5/12">
                      <label className="block text-[#777777]" htmlFor="Name">
                        Name
                      </label>
                      <input
                        className={`border-2 rounded-lg w-full py-1 px-4 text-gray-700 leading-none focus:bg-white border-transparent focus:border-transparent focus:ring-1 ${"bg-[#E4E6FF]"}`}
                        id="Name"
                        type="text"
                        name="Name"
                        value={null}
                        onChange={null}
                        autoComplete="off"
                        disabled={false}
                      />
                    </div>
                    <div className="w-5/12">
                      <label
                        className="block text-[#777777]"
                        htmlFor="Password"
                      >
                        Password
                      </label>
                      <input
                        className={`border-2 rounded-lg w-full py-1 px-4 text-gray-700 leading-none focus:bg-white border-transparent focus:border-transparent focus:ring-1 ${"bg-[#E4E6FF]"}`}
                        id="Password"
                        type="text"
                        name="Password"
                        value={null}
                        onChange={null}
                        autoComplete="off"
                        disabled={false}
                      />
                    </div>
                    <div className="w-5/12">
                      <label
                        className="block text-[#777777]"
                        htmlFor="Department"
                      >
                        Department
                      </label>
                      <input
                        className={`border-2 rounded-lg w-full py-1 px-4 text-gray-700 leading-none focus:bg-white border-transparent focus:border-transparent focus:ring-1 ${"bg-[#E4E6FF]"}`}
                        id="Department"
                        type="text"
                        name="Department"
                        value={null}
                        onChange={null}
                        autoComplete="off"
                        disabled={false}
                      />
                    </div>
                    <div className="w-5/12">
                      <label className="block text-[#777777]" htmlFor="Contact">
                        Contact Number
                      </label>
                      <input
                        className={`border-2 rounded-lg w-full py-1 px-4 text-gray-700 leading-none focus:bg-white border-transparent focus:border-transparent focus:ring-1 ${"bg-[#E4E6FF]"}`}
                        id="Contact"
                        type="text"
                        name="Contact"
                        value={null}
                        onChange={null}
                        autoComplete="off"
                        disabled={false}
                      />
                    </div>
                    <div className="w-5/12">
                      <label className="block text-[#777777]" htmlFor="Email">
                        Email ID
                      </label>
                      <input
                        className={`border-2 rounded-lg w-full py-1 px-4 text-gray-700 leading-none focus:bg-white border-transparent focus:border-transparent focus:ring-1 ${"bg-[#E4E6FF]"}`}
                        id="Email"
                        type="text"
                        name="Email"
                        value={null}
                        onChange={null}
                        autoComplete="off"
                        disabled={false}
                      />
                    </div>
                  </div>
                  <button className="bg-[#6767ce] hover:bg-[#4242A8] text-white py-1 rounded-lg w-1/6 mt-5">
                    ADD
                  </button>
                </form>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminModal;
